import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { formulaPoints, productImage } from '../../data/presellContent';
export function Solution() {
  return <section id="solution" className="w-full bg-[#F7F9F8]" data-id="element-64" data-mp="n9ji9wd0d0yk">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-65" data-mp="nc4jqk9e9evs">
        <div className="grid lg:grid-cols-[0.85fr_1fr] gap-10 lg:gap-16 items-center" data-id="element-66" data-mp="s7tfsdm7gdnc">
          <div className="bg-white rounded-2xl border border-[#E5E9E7] p-4 md:p-6 flex items-center justify-center overflow-hidden" data-id="element-67" data-mp="3rpb62rjl0tch">
            <img src={productImage} alt="Joint Genesis bottle shown alongside its ingredients: Mobilee, French Maritime Pine Bark, Ginger Root, Boswellia Serrata and BioPerine" className="w-full h-auto object-contain rounded-lg" loading="lazy" data-id="element-68" data-mp="3vrxra9lqzg0p" />
          </div>

          <div data-id="element-69" data-mp="1kxjsqjc3p9hv">
            <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug" data-id="element-70" data-mp="1kx0mw0zq6bk7">
              A New Approach Designed To Support Natural Joint Lubrication
            </h2>

            <p className="mt-6 text-lg text-[#4A5D50] leading-relaxed" data-id="element-71" data-mp="2yfmm7kspgol2">
              Joint Genesis is a formula created to support the body's natural
              joint lubrication and help people feel more comfortable in daily
              movement.
            </p>

            <ul className="mt-8 space-y-3" data-id="element-72" data-mp="2oj9simx5uaqb">
              {formulaPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-73" data-mp="2jjdseyrl33g1">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-[#EAF1EE] flex items-center justify-center shrink-0" data-id="element-74" data-mp="2eqb2d0m0mc4l">
                    <CheckIcon className="w-3.5 h-3.5 text-[#3F8C86]" aria-hidden="true" data-id="element-75" data-mp="2aq0o70o2kfen" />
                  </span>
                  <span className="text-lg text-[#22322C]" data-id="element-76" data-mp="20q9sivnrvucz">{point}</span>
                </li>)}
            </ul>

            <div className="mt-9 bg-white border border-[#D8E4E1] rounded-2xl px-6 py-7" data-id="element-77" data-mp="1vt9v194znzxh">
              <p className="text-sm font-semibold tracking-[0.12em] text-[#7C9082] uppercase" data-id="element-78" data-mp="1m3kuky965p8p">
                From the maker of Joint Genesis
              </p>
              <p className="mt-3 text-xl md:text-2xl font-bold text-[#22322C] leading-snug" data-id="element-79" data-mp="1d4zgpgen6ye9">
                Its formula may help{' '}
                <span className="text-[#3F8C86]" data-id="element-80" data-mp="1h6b5jjpozfle">
                  multiply joint lubrication up to 10X
                </span>
                .
              </p>
            </div>

            <div className="mt-9" data-id="element-81" data-mp="29t5f3lkz0uk3">
              <CtaButton supportingText="" data-id="element-82" data-mp="29wkz92ti4tsd" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}